var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48743 0.5C3.17925 0.5 0.487427 3.19191 0.487427 6.5C0.487427 9.80809 3.17933 12.5 6.48743 12.5C9.79552 12.5 12.4874 9.80809 12.4874 6.5C12.4874 3.19191 9.79552 0.5 6.48743 0.5ZM6.48743 1.44742C9.28352 1.44742 11.5401 3.70394 11.5401 6.50006C11.5401 9.29615 9.28355 11.5527 6.48743 11.5527C3.69131 11.5527 1.4348 9.29618 1.4348 6.50006C1.4348 3.70397 3.69131 1.44742 6.48743 1.44742ZM6.48743 2.2369C6.22585 2.2369 6.01371 2.44902 6.01371 2.71061V6.50008C6.01371 6.67531 6.1092 6.82763 6.25051 6.90957L9.26038 8.64635C9.48694 8.7772 9.77594 8.70021 9.90679 8.47366C10.0376 8.2471 9.96065 7.9581 9.73409 7.82725L6.96112 6.22859V2.71064C6.96112 2.44906 6.74912 2.2369 6.48743 2.2369Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.18a9b33917b5a0fa3beead9e1d63c344.svg";
export { ForwardRef as ReactComponent };